import React from 'react';

function Clock({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <polyline points="12 6 12 12 16 14" />
      <circle cx="12" cy="12" r="10" />
    </svg>
  );
}

export default Clock;
